import axios from 'axios';
import config from 'config';
import qs from 'qs';

const BASE_URL = config.swarmApiUrl;

const client = axios.create({withCredentials: true});

export const authMe = () => client.get(`${BASE_URL}/auth/me`);
export const authLogin = (username, password) => client.post(`${BASE_URL}/auth/login`, {username, password});
export const authLogout = () => client.get(`${BASE_URL}/auth/logout`);

export const directoryGet = () => client.get(`${BASE_URL}/directory`);
export const history = (nodeId, propId, {from, to}) => client.get(`${BASE_URL}/history/${encodeURIComponent(nodeId)}/${encodeURIComponent(propId)}${
    qs.stringify({from: from.toISOString(), to: to.toISOString()}, {addQueryPrefix: true})
}`);
export const request = (nodeId, propertyId, value) => client.post(`${BASE_URL}/request`, {nodeId, propertyId, value});
